import { Icon } from '@/public/assets/v2/images/icons'
import { cssClass } from '@/shared/utils'
import { Notifications } from 'containers/notifications'
import { useNotifications } from 'containers/notifications/hooks/notifications'
import { useSubscription } from 'containers/profile/hooks/useProfile'
import { Avatar } from 'containers/recommendations/Avatar'
import { useUser } from 'containers/user/hooks/useUser'
import Link from 'next/link'
import { useMemo, useState } from 'react'
import styles from './styles/Navbar.module.scss'

interface NavbarProps {
  isAuth: boolean
}

const profileMenuItems = [
  {
    label: 'Overview',
    href: '/',
  },
  {
    label: 'Analytics',
    href: '/[username]/analytics',
  },
  {
    label: 'Projects',
    href: '/[username]/projects',
  },
  {
    label: 'Highlights',
    href: '/[username]/highlights',
  },
  {
    label: 'Settings',
    href: '/settings',
  },
]

export const Navbar = ({ isAuth }: NavbarProps) => {
  const { user } = useUser()
  const { isSubscribed } = useSubscription()
  const { newNotifications } = useNotifications()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)

  const menuItems = useMemo(() => {
    return profileMenuItems.map((item) => ({
      ...item,
      href: item.href.replace(
        '[username]',
        user?.usernameLower ?? user?.username?.toLocaleLowerCase()
      ),
    }))
  }, [user])

  if (!isAuth) return null

  return (
    <>
      <Notifications
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
      />
      <div className={styles.navbarV3}>
        {!isSubscribed && (
          <Link href="/checkout">
            <button className={styles.premiumButton}>
              <Icon.CreatorlandIcon />
              <span>Get Premium</span>
            </button>
          </Link>
        )}

        <Link href="/inbox">
          <Icon.InboxIcon className={styles.chatIcon} />
        </Link>

        <button
          onClick={() => setIsNotificationsOpen(!isNotificationsOpen)}
          className={styles.notificationsButton}
        >
          <Icon.BellIcon />
          {newNotifications > 0 && (
            <div
              className={cssClass([
                styles.notificationsBadge,
                newNotifications > 99 ? styles.notificationsBadgeLarge : '',
              ])}
            >
              {newNotifications > 99 ? '99+' : newNotifications}
            </div>
          )}
        </button>

        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className={styles.profileButton}
        >
          <Avatar image={user?.avatar} size={32} custonBorderRadius={100} />

          {isMenuOpen && (
            <div className={styles.profileMenu}>
              {menuItems.map((item) => (
                <Link key={item.label} href={item.href}>
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </button>
      </div>
    </>
  )
}
